// Shared styling keeps the credit-card tables visually consistent.
export const statementTablePaperSx = { width: '100%', overflow: 'hidden', border: 0, borderRadius: '12px 12px 0 0' };

export const statementTableContainerSx = {
  height: 'auto',
  maxHeight: 'none',
  // Keep scrollbar styling local to the statements table, including horizontal overflow.
  '&::-webkit-scrollbar': { width: 10, height: 10, backgroundColor: '#f4f5f7' },
  '&::-webkit-scrollbar-track': { backgroundColor: '#f4f5f7', borderRadius: '10px' },
  // The single-line header is 57px tall (24px text, 32px padding, 1px border).
  '&::-webkit-scrollbar-track:vertical': { marginTop: '57px' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#a5adba',
    borderRadius: '10px',
    border: '2px solid #f4f5f7',
    '&:hover': { backgroundColor: '#6b778c' },
  },
  '&::-webkit-scrollbar-corner': { backgroundColor: '#f4f5f7' },
  '@supports not selector(::-webkit-scrollbar)': {
    scrollbarWidth: 'thin',
    scrollbarColor: '#a5adba #f4f5f7',
  },
};

export const statementTableSx = {
  // Let wide labels determine column widths instead of clipping at the right edge.
  width: 'max-content',
  minWidth: '100%',
  // Override Bootstrap's inherited cell borders inside legacy .table wrappers.
  '&& .MuiTableCell-root': { fontSize: '1rem', px: '20px', borderTop: 0, borderBottom: '1px solid #e5e7eb' },
  // Keep separators between rows without drawing a border along the table bottom.
  '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': { borderBottom: 0 },
  '& .MuiTableCell-head': { fontSize: '13px', color: '#475467' },
  '& .MuiTableSortLabel-root.Mui-active': { color: '#1d2939' },
  '& .MuiTableSortLabel-icon': { fontSize: '16px' },
};

export const statementTableHeaderSx = { backgroundColor: '#f4f5f7', fontWeight: 500, whiteSpace: 'nowrap', lineHeight: '24px', py: '16px' };
